import {styled, TableCell, tableCellClasses, TableRow} from "@mui/material";

export const CourseTableHeaderCell = styled(TableCell)(({theme}) => ({
    [`&.${tableCellClasses.head}`]: {
        fontSize: 16,
        fontWeight: 500,
        paddingBottom: "5px",
        padding: 8,
        fontFamily: "'Repro', sans-serif",
        [theme.breakpoints.down('md')]: {
            fontFamily: "'Lato', sans-serif",
            fontWeight: 700,
        }
    }
}));

export const CourseTableSecondHeaderCell = styled(TableCell)(({theme}) => ({
    [`&.${tableCellClasses.head}`]: {
        fontSize: 14,
        fontWeight: 700,
        padding: 8,
        fontFamily: "'Lato', sans-serif"
    }
}));

export const CourseTableCell = styled(TableCell)(({theme}) => ({
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        padding: 8,
        fontFamily: "'Repro', sans-serif",
        fontWeight: 400,
        [theme.breakpoints.down('md')]: {
            fontFamily: "'Lato', sans-serif"
        }
    }
}));

export const CourseTableRow = styled(TableRow)(({theme}) => ({
    '&:nth-of-type(even)': {
        backgroundColor: "#FCFAFA",
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    }
}));